module.exports = __webpack_public_path__ + "static/img/piglet2.a0b81c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/piglet2.png
// module id = 5Q2H
// module chunks = 2